import * as React from "react";
import { connect } from 'react-redux';
import './SalesChatLoadingScreen.css'
//@ts-ignore
import animationData from './Sales-chat-loading-ani02.json';
import Lottie from 'react-lottie';

class SalesChatLoadingScreen extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.state = {
        }
        this.handleResize = this.handleResize.bind(this);
        window.addEventListener('resize', this.handleResize)
    }

    handleResize() {
        this.setState({ render: !this.state.render })
    }

    render() {

        const defaultOptions = {
            loop: true,
            autoplay: true,
            animationData: animationData,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
            },

        };
        let lottieSize = 50;
        let topPadding = (((window.innerHeight - (lottieSize + 200)) / 2) ) + "px";
        return (
            <>
                <div className="SalesChatLoadingDiv" style={{ paddingTop: topPadding }}>
                    <img className="CrownImage" alt="" src="./images/crown-icon.svg" />
                    <Lottie className="SalesChatLottie" options={defaultOptions}
                        height={lottieSize}
                        width={lottieSize*2}
                        isStopped={false}
                        isPaused={false}
                    />
                </div>
            </>
        );
    }
}

export default connect()(SalesChatLoadingScreen)